interface IWhatsappIconProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a Whatsapp Icon.
 */
export function WhatsappIcon({ className }: IWhatsappIconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <g id="whatsapp-icon">
        <path d="M20 4c-2.1-2.1-5-3.3-8-3.3C5.8.7.8 5.7.8 11.9c0 2 .5 3.9 1.5 5.6L.7 23.3l5.9-1.6c1.6.9 3.5 1.4 5.4 1.4 6.2 0 11.2-5 11.2-11.2.1-3-1.1-5.8-3.2-7.9zm-8 17.2c-1.7 0-3.3-.4-4.7-1.3l-.3-.2-3.5.9.9-3.4-.2-.4c-.9-1.5-1.4-3.2-1.4-5 0-5.1 4.2-9.3 9.3-9.3 2.5 0 4.8 1 6.6 2.7s2.7 4.1 2.7 6.6c0 5.2-4.2 9.4-9.4 9.4z" />

        <linearGradient
          gradientTransform="translate(2510.346 -811.506) scale(2.0408)"
          gradientUnits="userSpaceOnUse"
          id="background-gradient"
          x1={-1224.199}
          x2={-1224.199}
          y1={408.743}
          y2={398.175}
        >
          <stop offset={0} stopColor="#20b038" />

          <stop offset={1} stopColor="#60d66a" />
        </linearGradient>

        <path
          d="m1.3 22.7 1.5-5.5c-.9-1.6-1.4-3.5-1.4-5.3 0-6 4.8-10.8 10.6-10.8 2.9 0 5.5 1.1 7.6 3.1 2 2 3.1 4.7 3.1 7.6 0 5.9-4.8 10.7-10.7 10.7-1.8 0-3.5-.4-5.1-1.3l-5.6 1.5z"
          fill="url(#background-gradient)"
        />

        <path
          d="M9.3 7.1c-.2-.4-.4-.4-.6-.4h-.5c-.3 0-.6 0-.8.3-.3.3-1 .9-1 2.3s1 2.7 1.1 2.9c.1.2 1.9 3.1 4.7 4.2 2.3.9 2.8.7 3.3.7s1.6-.7 1.9-1.3c.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.5-.3-.3-.1-1.6-.8-1.9-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1s-1.2-.4-2.2-1.4c-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5s.2-.3.3-.5c.1-.2 0-.3 0-.5-.1-.1-.7-1.5-.9-2.1z"
          fill="#fff"
        />

        <path
          d="M19.9 3.9C17.8 1.9 15 .7 12 .7 5.9.7 1 5.7 1 11.8c0 2 .5 3.9 1.5 5.5L.9 23l5.9-1.5c1.6.9 3.4 1.3 5.3 1.3 6.1 0 11.1-5 11.1-11.1-.1-2.9-1.2-5.7-3.3-7.8zM12 21c-1.7 0-3.3-.4-4.7-1.3l-.3-.2-3.5.9 1-3.4-.2-.3c-.9-1.5-1.4-3.2-1.4-4.9 0-5.1 4.1-9.2 9.2-9.2 2.5 0 4.8 1 6.5 2.7 1.7 1.7 2.7 4.1 2.7 6.5-.1 5.1-4.2 9.2-9.3 9.2z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
